<template>
  <div class="versionSearchForm">
    <el-form
      ref="versionSearchForm"
      :model="searchForm"
      :inline="true"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="选择区域：" prop="areaCode">
        <el-cascader
          v-model="searchForm.areaCode"
          :options="areaData"
          :props="areaProps"
          placeholder="全部省/市/区县"
          @change="handleChange"
        />
      </el-form-item>
      <el-form-item label="选择学校：" prop="schoolCode">
        <el-select
          v-model="searchForm.schoolCode"
          name="schoolCode"
          size="medium"
          class="handle-form-input"
          filterable
          placeholder="全部学校"
          @change="handleChangeSchool"
        >
          <el-option
            v-for="item in schoollist"
            :key="item.schoolCode"
            :label="item.name"
            :value="item.schoolCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="historyType === 2"
        label="选择楼栋："
        prop="buildingId"
      >
        <el-select
          v-model="searchForm.buildingId"
          name="buildingId"
          size="medium"
          style="width: 200px"
          placeholder="全部楼栋"
          @change="handleChangeRoom"
        >
          <el-option
            v-for="item in roomlistCopy"
            :key="item.buildingId"
            :label="item.buildingName"
            :value="item.buildingId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="historyType === 2"
        label="选择教室："
        prop="buildingId"
      >
        <el-select
          v-model="searchForm.roomId"
          name="roomId"
          size="medium"
          style="margin-left: 5px; width: 200px"
          value-key="roomName"
          placeholder="全部教室"
          @change="handleChangeroomSimpleVOList"
        >
          <el-option-group
            v-for="group in roomSimpleVOList"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item.roomId"
              :label="item.roomName"
              :value="item.roomId"
            />
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="historyType === 1"
        label="选择年级："
        prop="gradeCode"
      >
        <el-select
          v-model="searchForm.gradeCode"
          name="gradeCode"
          size="medium"
          style="width: 200px"
          placeholder="全部年级"
          @change="handleupgradeType"
        >
          <el-option
            v-for="item in gradelistCopy"
            :key="item.grade"
            :label="item.gradeName"
            :value="item.grade"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="historyType === 1"
        label="选择班级："
        prop="classCode"
      >
        <el-select
          v-model="searchForm.classCode"
          name="classCode"
          size="medium"
          style="margin-left: 5px; width: 200px"
          value-key="name"
          placeholder="全部班级"
          @change="handleChangeclassVOList"
        >
          <el-option-group
            v-for="group in classVOList"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item.name"
              :label="item.name"
              :value="item.code"
            />
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="handleSearch"
        >
          查询
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="medium"
          @click="resetInput"
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VersionSearchForm',
  props: {
    historyType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        areaCode: '',
        schoolCode: '',
        buildingId: '',
        roomId: '',
        gradeCode: '',
        classCode: ''
      },
      areaProps: {
        value: 'code',
        label: 'name',
        children: 'children',
        emitPath: false
      },
      roomSimpleVOList: [],
      roomVOList: [],
      classVOList: [],
      classVOListResult: []
    };
  },
  computed: {
    ...mapGetters(['uploadUrl', 'areaData', 'schoollist', 'roomlist', 'gradelist', 'userInfo']),
    gradelistCopy: {
      get() {
        return this.gradelist;
      },
      set() {
        this.$store.dispatch('getNodesclass', { empty: true });
      }
    },
    roomlistCopy: {
      get() {
        return this.roomlist;
      },
      set() {
        this.$store.dispatch('getNodesclass', { empty: true });
      }
    }
  },
  mounted() {
  },
  methods: {
    // 选择区域
    handleChange(val) {
      this.searchForm = { areaCode: val, schoolCode: '', buildingId: '', roomId: '', gradeCode: '', classCode: '' };
      this.roomSimpleVOList = [];
      this.classVOList = [];
      this.gradelistCopy = [];
      this.roomlistCopy = [];
      this.$store.dispatch('getNodesSchool', this.searchForm.areaCode);
    },
    // 条件查询
    handleSearch() {
      this.$emit('handleSearchFilter', this.searchForm);
    },
    resetInput() {
      this.searchForm = {
        areaCode: '',
        schoolCode: '',
        buildingId: '',
        roomId: '',
        gradeCode: '',
        classCode: ''
      };
      this.$emit('resetInput', this.searchForm);
    },
    // 选择学校
    handleChangeSchool(val) {
      this.searchForm.schoolCode = val;
      if (this.historyType === 1) {
        this.getNodesChanageclass();
      } else if (this.historyType === 2) {
        this.getNodesChanageroom();
      }
    },
    // 获取所在教室
    getNodesChanageroom(val) {
      // 发布到教室页面回显
      this.roomSimpleVOList = [];
      const that = this;
      that.searchForm.roomId = '';
      that.searchForm.buildingId = '';
      var option = {
        cunwAppUpgradeId: this.searchForm.cunwAppUpgradeId,
        schoolCode: this.searchForm.schoolCode,
        areaCode: this.searchForm.areaCode
      };
      this.$store
        .dispatch('getNodesroom', option)
        .then((result) => {
          result.forEach((item) => {
            var optionSubitem = [];
            if (item.roomSimpleVOList && item.roomSimpleVOList.length > 0) {
              item.roomSimpleVOList.forEach((subitem) => {
                optionSubitem.push(subitem);
              });
            }
            if (optionSubitem.length > 0) {
              that.roomSimpleVOList.push({
                label: item.buildingName,
                buildingId: item.buildingId,
                options: optionSubitem
              });
            }
          });
          that.roomVOList = that.roomSimpleVOList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取所在班级
    getNodesChanageclass() {
      // 发布到班级页面回显
      this.classVOList = [];
      const that = this;
      that.searchForm.gradeCode = '';
      that.searchForm.classCode = '';
      var option = {
        cunwAppUpgradeId: this.searchForm.cunwAppUpgradeId,
        schoolCode: this.searchForm.schoolCode,
        areaCode: this.searchForm.areaCode
      };
      this.$store
        .dispatch('getNodesclass', option)
        .then((result) => {
          result.forEach((item) => {
            var optionSubitem = [];
            if (item.classVOList && item.classVOList.length > 0) {
              item.classVOList.forEach((subitem) => {
                optionSubitem.push(subitem);
              });
            }
            if (optionSubitem.length > 0) {
              that.classVOList.push({
                label: item.gradeName,
                gradeCode: item.grade,
                options: optionSubitem
              });
            }
          });
          that.classVOListResult = that.classVOList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 选择楼栋
    handleChangeRoom(val) {
      this.searchForm.buildingId = val;
      this.searchForm.roomId = '';
      var result = [];
      for (var i = 0; i < this.roomVOList.length; i++) {
        if (this.roomVOList[i].buildingId === val) {
          result.push(this.roomVOList[i]);
        }
      }
      this.roomSimpleVOList = result;
    },
    // 选择教室
    handleChangeroomSimpleVOList(val) {
      this.searchForm.roomId = val;
    },
    // 选择年级
    handleupgradeType(val) {
      this.searchForm.gradeCode = val;
      this.searchForm.classCode = '';
      var result = [];
      for (var i = 0; i < this.classVOListResult.length; i++) {
        if (this.classVOListResult[i].gradeCode === val) {
          result.push(this.classVOListResult[i]);
        }
      }
      this.classVOList = result;
    },
    // 选择班级
    handleChangeclassVOList(val) {
      this.searchForm.classCode = val;
    }
  }
};
</script>

